import ModalDeleteFilled from '../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import ModalSmallFilled from '../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { ModalEditComponentProps } from '../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../utils/hooks/useTwinTranslation'


interface ModalChangeActiveCustomerContactPersonProps extends ModalEditComponentProps { }

const ModalChangeActiveCustomerContactPerson: React.FC<ModalChangeActiveCustomerContactPersonProps> = ({ setOpened, onSubmit, allRowData }) => {
    if (allRowData?.active === false) {
        return <ModalReactivateCustomerConctactPerson {...{ setOpened, onSubmit, allRowData }} />
    } else {
        return <ModalDeleteCustomerConctactPerson {...{ setOpened, onSubmit, allRowData }} />
    }
}

interface ModalDeleteCustomerConctactPersonProps extends ModalEditComponentProps { }

const ModalDeleteCustomerConctactPerson: React.FC<ModalDeleteCustomerConctactPersonProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/customer/customerContactPerson/updateCustomerContactPerson',
        data: {
            id: allRowData?.id,
            active: false
        }
    })
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureUnactiveContactPerson', '¿Seguro que quieres desactivar esta persona de contacto?'),
            subtitle: t('onceDisabledCanRecoverM', 'Una vez desactivado podrás recuperarlo'),
            buttonAccept: t('disable', 'Desactivar'),
        }} />
    )
}

interface ModalReactivateCustomerConctactPersonProps extends ModalEditComponentProps { }

const ModalReactivateCustomerConctactPerson: React.FC<ModalReactivateCustomerConctactPersonProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/customer/customerContactPerson/updateCustomerContactPerson',
        data: {
            id: allRowData?.id,
            active: true
        }
    })
    return (
        <ModalSmallFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={{
            title: t('sureReactiveThisCustomerContactPerson', '¿Seguro que quieres reactivar esta persona de contacto?'),
            subtitle: t('onceReactivatedAbleInCustomerContactPersonList', 'Una vez reactivado volverá a aparecer en el listado de personas de contacto'),
            buttonAccept: t('reactivate', 'Reactivar')
        }} />
    )
}

export default ModalChangeActiveCustomerContactPerson